import '../Common.scss';
import Footer from '../../../components/Footer';
import SectionTabs from '../../../components/SectionTabs';
import GalleryGrid from '../../../components/GalleryGrid';
import { motion } from "framer-motion";

export const supportTabs = [
  { title: '후원현황', url: '/supportImage' },
  { title: '후원안내', url: '/supporter' },
];

// 후원 > 후원현황
export default function G2_SupportImage (props:any) {

  return (
    <div className="program-cover">

      <motion.div
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true, amount: 0.2 }}
      >
      <div>
        <SectionTabs title="후원" tabs={supportTabs}/>
        <GalleryGrid endpoint="/main/getgallerysupport" emptyText="등록된 후원현황이 없습니다."/>
      </div>
      </motion.div>
      <Footer />
    </div>
  )
}
